const handleFooter = () => {
    function footerMenuToggle() {
        if (window.innerWidth <= 767) {
            const footerLinks = document.querySelectorAll('#footer-main-menu > .menu-item');
            if (footerLinks) {
                footerLinks.forEach((footerLink) => {
                    footerLink.addEventListener('click', (e) => {
                        e.stopImmediatePropagation();
                        $(footerLink).find('.dropdown-menu').slideToggle();
                    });
                });
            }
        }
    }

    function init() {
        footerMenuToggle();
    }

    init();
};

function footerPlacement() {
    // setTimeout(function() {
    //     const footer = document.querySelectorAll('.injected-footer');
    //     const hubFooter = document.querySelector('#injected-footer');
    //     if (footer && hubFooter) {
    //         footer.forEach((hubs) => {
    //             hubFooter.insertAdjacentElement('afterbegin', hubs);
    //         });
    //     }
    // }, 50);
}


module.exports = { handleFooter, footerPlacement };


// WEBPACK FOOTER //
// ./scriptPartials/corpHeaderFooter/handleFooter.js